import {getJsonFromUrl} from './helpers';

export function findApplicant() {
    const getParams = getJsonFromUrl(document.location.search);
    if (getParams.competition_code) {
        const competition = $_pro(`.tr-accordion[data-code=${getParams.competition_code}]`).get(0);
        if (competition) {
            const $competition = $_pro(competition);
            const competitionIndex = $competition.data('id');
            const competitionApplicants = $_pro(`tr[data-tr-id=${competitionIndex}]`).get(0);
            if (competitionApplicants) {
                const $competitionApplicants = $_pro(competitionApplicants);
                if (!$competitionApplicants.is(':visible')) {
                    $competition.click();
                }
                // скролл к абитуриенту
                if (getParams.applicant_code) {
                    const applicant = $competitionApplicants.find(`td[data-code=${getParams.applicant_code}]`).get(0);
                    if (applicant) {
                        applicant.scrollIntoView({block: 'center', behavior: 'smooth'});
                        $_pro(applicant.closest('tr')).addClass('applicant-active');
                    }
                }
            }
        }
    }
}
